export enum EarnRateType {
  Litres = "Litres"
}
export enum LoyaltySchemeType {
  FlyBuys = "FlyBuys",
  Airpoints = "Airpoints"
}
export enum OfferLevelType {
  Account = "Account",
  Card = "Card",
  CostCentre = "CostCentre"
}

export interface ILoyaltyState {
  isLoading: boolean;
  segmentOffer: ISegmentOffer;
  // store copy of original value to use with Discard changes
  segmentOfferOriginal: ISegmentOffer;
  segmentOfferList: ISegmentOfferResponse[];
  segmentOfferListPaginationTotal: number;
  channelList?: IChannel[];
  segmentList?: ISegment[];
  accountOffer: IAccountOffer;
  accountOfferOriginal: IAccountOffer;
  accountOfferList: IAccountOfferResponse[];
  accountOfferListPaginationTotal: number;
  customerSearchList: ICustomerSearchResponse[];
  customerSearchInProgress: boolean;
  customerList: ICustomerListResponse[];
  customerListPaginationTotal: number;
  customer: ICustomer;
  customerCardsList: ICustomerCard[];
  customerCardsListPaginationTotal: number;
  customerCardsListShowModal: boolean;
  activeCustomerCard?: ICustomerCard;
  customerPointsList: IPointsListResponse[];
  customerTransactionList: ITransactionListResponse[];
  activeCampaign: ICampaign;
  activeCampaignOriginal: ICampaign;
  campaignList: ICampaign[];
  campaignListPaginationTotal: number;
  dataTables: {
    accountOffers: {
      pagination: IPagination
    };
    segmentOffers: {
      pagination: IPagination
    };
    campaigns: {
      pagination: IPagination
    };
    customerCards: {
      pagination: IPagination
    };
  };
}

export interface ISegment {
  id: number;
  name: string;
  value: string;
}

export interface IEarnRate {
  accumulationQuantity: number;
  quantity: number;
  earnRateUnit: EarnRateType;
  loyaltyScheme: LoyaltySchemeType;
}

export interface IChannel {
  id: number;
  name: string;
  value: string;
}

export interface ISegmentOffer {
  id: number;
  segment: ISegment;
  isEligible: boolean;
  level: OfferLevelType;
  channels: IChannel[];
  earnRates: IEarnRate[];
  airpointsEarnRateQuantity: number | null;
  flyBuysEarnRateQuantity: number | null;
}

export interface ISegmentOfferResponse {
  id: number;
  segment: ISegment;
  isEligible: boolean;
  channels: IChannel[];
  level: OfferLevelType;
  earnRates: IEarnRate[];
}

export interface IAccountOffer extends ICustomerSearchResponse {
  id?: number;
  level: OfferLevelType;
  isEligible: boolean;
  channels: IChannel[];
  earnRates: IEarnRate[];
  airpointsEarnRateQuantity: number | null;
  flyBuysEarnRateQuantity: number | null;
}

export interface IAccountOfferResponse extends ICustomerSearchResponse {
  id?: number;
  level: OfferLevelType;
  isEligible: boolean;
  channels: IChannel[];
  earnRates: IEarnRate[];
}

export interface ICustomerSearchResponse {
  accountNumber: number | null;
  customerName: string;
  computedTitle?: string;
  applicationNumber?: number;
  contactName?: string;
  contactTitle?: string;
  segment?: string;
  customerType?: string;
  emailAddress?: string;
}

export interface ICustomerListResponse {
  accountNumber: number;
  applicationNumber: number;
  customerName: string;
  contactName: string;
  contactTitle: string;
  segment: string;
  customerType: string;
  emailAddress: string;
}

export interface IPointsListResponse {
  accountNumber: number;
  loyaltyNumber: string;
  points?: number | null;
  loyaltyScheme: string;
}

export interface ITransactionListResponse {
  transactionDate: Date | null;
  accountNumber: number;
  locationName: string;
  loyaltyNumber: string;
  points?: number | null;
  pointsAllocated?: number | null;
  loyaltyScheme: string;
}

export interface IPagination {
  descending?: boolean;
  page?: number;
  rowsPerPage?: number; // -1 for All"
  sortBy?: string;
  totalItems?: number;
}

export interface ICustomer extends ICustomerListResponse {
  invoiceEmailAddress: string;
  offer: {
    id: number;
    isEligible: boolean;
    channels: IChannel[];
    level: OfferLevelType;
    earnRates: IEarnRate[];
    isAccountOffer: boolean;
  };
}

export interface ICustomerCard {
  cardNumber: string;
  cardStatus: string;
  expiry: Date;
  rego: string;
  driverName: string;
  costCentreCode: string;
  loyaltyNumber: string;
  loyaltyScheme: LoyaltySchemeType;
}

export interface ICampaign {
  id?: number | null;
  name: string;
  startDate: string | null;
  endDate: string | null;
  segments: ISegment[];
  channels: IChannel[];
  flyBuysMultiplier?: number;
  airpointsMultiplier?: number;
  multipliers: ICampaignMultiplier[];
  lastUpdatedBy: string | null;
  lastUpdated: Date | null;
}

export interface ICampaignMultiplier {
  loyaltyScheme: LoyaltySchemeType;
  multiplier: number;
}
